import { Controller } from "stimulus"

export default class extends Controller {

  open() {
    this.bookableBoxController.showBookableBox()
  }

  get bookableBoxController() {
    return this.getControllerByIdentifier("widget--box")
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }
}
